import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import Header from "./Header";
import MaterialIcon from "src/shared/components/MaterialIcon";
import ShadowCard from "src/shared/components/ShadowCard";

const TeacherTips: React.FC<{
  tips: string[];
  onClose: () => void;
}> = ({ tips, onClose }) => {
  const tipList = tips.map((tip, index) => {
    return (
      <ShadowCard sx={cardStyle} key={index.toString()}>
        {tip}
      </ShadowCard>
    );
  });

  return (
    <div>
      <Header icon={<MaterialIcon icon="close" />} onIconClick={onClose} title="Teacher Tips" />
      <div sx={appStyle}>{tipList}</div>
    </div>
  );
};

export default TeacherTips;

const appStyle: ThemeUIStyleObject = {
  textAlign: "center",
  paddingX: "dt_s",
  paddingBottom: "dt_m",
};

const cardStyle: ThemeUIStyleObject = {
  borderRadius: "dt_radius_s",
  padding: "dt_s",
  maxWidth: "500px",
  margin: "auto",
  marginTop: "dt_s",
  fontSize: "16px",
  lineHeight: "1.29",
  color: "dt_content_primary",
};
